import React from 'react';
import Button from '../Button/Button';
import { useLanguage } from '../../contexts/LanguageContext';
import styles from './DeleteModal.module.css';

type DeleteModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onDelete: () => void;
    branchName: string;
    /** Optional custom message. When not provided, uses default: "All the data will be deleted and this action is irreversible." */
    message?: string;
};

const DeleteModal: React.FC<DeleteModalProps> = ({ isOpen, onClose, onDelete, branchName, message }) => {
    // O3 (SO-38) — localized confirm copy (keys in i18n/owner/myBusiness.ts).
    const { t } = useLanguage();
    const descText = message ?? t('mb.deleteModal.body');
    // #1201: Only render when open to prevent ghost Cancel/Delete buttons
    if (!isOpen) return null;
    return (
        <div className={`${styles.modalOverlay} ${styles.open}`}>
            <div className={`${styles.modalContent} ${isOpen ? styles.open : ''}`}>
                <button className={styles.closeButton} onClick={onClose} aria-label={t('mb.common.close')}>&times;</button>
                <div className={styles.textContainer}>
                    <h2 className={styles.header}>{t('mb.deleteModal.title').replace('{name}', branchName)}</h2>
                    <p className={styles.descText}>{descText}</p>
                </div>
                <div className={styles.buttonsContainer}>
                    <Button label={t('mb.common.cancel')} onClick={onClose} noAppearance={true} size='small' />
                    <div>
                        <Button label={t('mb.deleteModal.confirm')} onClick={onDelete} size='medium' backgroundColor='var(--destructive-fill)' fontColor='var(--on-destructive)' />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;
